import apiService from './apiService';

export const systemService = {
    create: (data) => apiService.post('/system-owners', data),
    getAll: () => apiService.get('/system-owners'),
    getById: (id) => apiService.get(`/system-owners/${id}`),
    update: (id, data) => apiService.put(`/system-owners/${id}`, data),
    setPermissions: (id, permissions) => apiService.put(`/system-owners/${id}/permissions`, { permissions }),
    suspend: (id, reason) => apiService.patch(`/system-owners/${id}/suspend`, reason ? { reason } : {}),
    reactivate: (id) => apiService.patch(`/system-owners/${id}/reactivate`),
    resetPassword: (id) => apiService.patch(`/system-owners/${id}/reset-password`),
    delete: (id) => apiService.delete(`/system-owners/${id}`),
    toggleStatus: (id) => apiService.patch(`/system-owners/${id}/toggle-status`)
};
